var React = require('react');

function Key (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 84C42.1503 84 52 74.1503 52 62C52 49.8497 42.1503 40 30 40C17.8497 40 8 49.8497 8 62C8 74.1503 17.8497 84 30 84Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M84 8L45.6 46.4M62 30L74 42L88 28L76 16","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Key.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Key;

Key.default = Key;
